import { TestBuyFollowUp } from "@coworker/types/lib/tasks/testbuy_followup";
import React from "react";

export function useTaskState(defaultTask: TestBuyFollowUp) {
  const [task, setTask] = React.useState(defaultTask);
  return { task, setTask };
}
